module.exports = __webpack_public_path__ + "fonts/NunitoSans_10pt-SemiBold.3df7c18d.ttf";